export const DEAL_RENT_TRAP_MAINPAGE = 'deal_rent_trap_mainpage';
export const NEWBUILDING_ONBOARDING_MAINPAGE = 'newbuilding_mainpage_onboarding_button';

export const BROWSER_EXPERIMENTS = [];

export const EXPERIMENTS = [DEAL_RENT_TRAP_MAINPAGE, NEWBUILDING_ONBOARDING_MAINPAGE];
